import {
  Card,
  Confirm,
  Icon,
  Link,
  PlacesMap,
  PaginateTable,
  Stack,
  Tab,
  Tabs,
  Tile,
  Title,
  Wrapper,
} from "components";
import { useGetQuery, usePostQuery } from "hooks";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { getRelativeTime } from "utils";
import { HostChat } from "../../games/chat";

const formatDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" });
};

const AddressEvents = ({ address, locationName, locationSlug }) => {
  const { data } = useGetQuery({ url: `/events?address_id=${address.id}` });
  const navigate = useNavigate();

  return (
    <PaginateTable
      addItem={() =>
        navigate("/events/new", {
          state: {
            address_id: address.id,
            address: { Location: { name: locationName, slug: locationSlug } },
          },
        })
      }
      data={data?.events?.rows || []}
      columns={[
        { title: "Name", key: "name" },
        {
          title: "Date",
          key: "start_time",
          render: (start_time) => formatDate(start_time),
        },
        {
          title: "Actions",
          key: "id",
          className: "right",
          render: (id) => (
            <>
              <Link to={`/events/${id}`}>
                <Icon icon="eye" />
              </Link>{" "}
              <Link to={`/events/${id}/edit`}>
                <Icon icon="pencil" />
              </Link>
            </>
          ),
        },
      ]}
    />
  );
};

const NameCard = styled(Card)`
  ${({ state, theme: { colors, defaults } }) => `
  &:after {
    position: absolute;
    left: 0.15rem;
    bottom: 0.15rem;
    top: 0.15rem;
    content: "";
    width: 0.25rem;
  }
    &.active:after{
      background: ${colors("success")};
    }
    &.deleted:after{ 
      background: ${colors("danger")};
    }
    &.pending:after{
      background: ${colors("warning")};
    }
    &.completed:after{
      background: ${colors("highlight")};
    }
    `}
`;

const ICON = {
  conditions: "home-thermometer-outline",
  dash: "monitor-dashboard",
  karaoke: "music",
  trivia: "head-lightbulb-outline",
};
export const HostPlace = () => {
  const navigate = useNavigate();

  const { slug } = useParams();

  const { data, reFetch } = useGetQuery({ url: `/host/places/${slug}` });

  const { post, setUrl } = usePostQuery({
    url: "/host/queue/",
    method: "DELETE",
  });

  const deleteQueue = (yes, id) => {
    if (!yes) return;
    post({ id });
    reFetch(true);
  };

  return (
    <Card>
      <Tabs>
        <Tab to={`/host/places/${slug}`} end>
          details
        </Tab>
        <Tab to={`/host/places/${slug}/activities`} end>
          activities
        </Tab>
        <Tab to={`/host/places/${slug}/events`} end>
          events
        </Tab>
        <Tab to={`/host/places/${slug}/chat`} end>
          chat
        </Tab>
      </Tabs>
      <Routes>
        <Route
          path={"/"}
          element={
            <>
              <PlacesMap
                className="user_place-show"
                locations={data?.location?.addresses}
                zoom={18}
              />
            </>
          }
        />
        <Route
          path={"/activities"}
          element={
            <PaginateTable
              addItem={() => navigate(`/host/places/${slug}/activity/add`)}
              title="Activities"
              columns={[
                {
                  title: " ",
                  key: "type",
                  render: (type, i, queue) => (
                    <NameCard className={queue.state}>
                      <Icon icon={ICON[type]} />
                    </NameCard>
                  ),
                },
                {
                  title: "Name",
                  key: "name",
                  render: (name, i, queue) => (
                    <Link
                      to={`/host/games/${queue.type}/${queue.slug}/${queue.type === "karaoke" ? "display" : ""}`}
                    >
                      {name} ({queue.slug})
                    </Link>
                  ),
                },
                {
                  title: "age",
                  className: "hide-sm",
                  key: "created_at",
                  render: (date) => {
                    return getRelativeTime(date);
                  },
                },
                {
                  title: "Actions",
                  key: "id",
                  className: "right",
                  render: (id, index, queue) => {
                    return (
                      <Stack horizontal={true}>
                        <Link
                          to={`/host/games/${queue.type}/${queue.slug}/${queue.type === "karaoke" ? "manage" : "edit"}`}
                        >
                          <Icon icon="pen" />
                        </Link>
                        <Confirm
                          handler={(yes) => deleteQueue(yes, queue.id)}
                          message={`Do you want to delete ${queue.type}/${queue.slug}`}
                        >
                          <Icon icon="trash-can" />
                        </Confirm>
                      </Stack>
                    );
                  },
                },
              ]}
              data={data?.location?.addresses.map((a) => a.Queues).flat() || []}
            />
          }
        />
        <Route
          path="/events"
          element={
            <>
              {data?.location?.addresses.map((address) => (
                <AddressEvents
                  key={address.id}
                  address={address}
                  locationName={data.location.name}
                  locationSlug={data.location.slug}
                />
              ))}
            </>
          }
        />
        <Route path="/chat" element={<HostChat />} />
      </Routes>
    </Card>
  );
};
